import {connect} from 'react-redux'
import PageInterface from '../components/PageInterface.jsx'
import {
  togglePage,
  closePage
} from '../../../actions/Actions.js'

// Map Redux state to component props
function mapStateToProps (state) {
  return {
    pageTitle: state && state.page && state.page.content &&
      state.page.content.title !== undefined
      ? state.page.content.title
      : 'Loading'
  }
}

function mapDispatchToProps (dispatch) {
  return {
    onTogglePage: () => dispatch(togglePage()),
    onClosePage: () => dispatch(closePage())
  }
}

// Connected Component
const PageInterfaceContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PageInterface)

export default PageInterfaceContainer
